export const GET_HOTSPOT_CLICK = "GET_HOTSPOT_CLICK";
export const SET_HOTSPOT_CLICK = "SET_HOTSPOT_CLICK";
